import { HttpClient, HttpClientModule } from "@angular/common/http";
import { NgModule, Optional, SkipSelf } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

const MODULES: any[] = [
    FlexLayoutModule,
    HttpClientModule,
];

@NgModule({
imports: [
    ...MODULES,
    TranslateModule.forRoot({
        loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
        }
    })
],
exports: [...MODULES, TranslateModule]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        
        if (parentModule) {
          throw new Error(`CoreModule has already been loaded.`);
        }
      }
}

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http);
  }